import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { TLM_MASTER } from "../apiRoutes";

const mutateUpdateTlmMaster = async ({ id,data }: { id:string; data: FieldValues }) => {
  return await axiosAuth.put(`${TLM_MASTER}${id}`, data);
};

const useUpdateTlmMastersMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateTlmMaster,
    ...queryParams,
  });

export default useUpdateTlmMastersMutation;
